module.exports = __webpack_public_path__ + "media/Aria of Tension (Dryad's theme).18a64a99.mp3";